
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import store from '@/store';
import { ClubVacationBookingClient, ClubVacationVoucherClient } from '@/services/Services';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class holidayBookingBox extends Vue {

    vouchers: OM.ClubVacationVoucher[] = [];

    created(){
        ClubVacationVoucherClient.getByUser(store.state.user.identifier)
        .then(x => {
            this.vouchers = x;
        })
    }

    get usedVouchers(){
        return this.vouchers.filter(x => x.usedOn);
    }

}
